const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "dms_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export class ApiError extends Error {
  constructor(status, detail) {
    super(detail);
    this.status = status;
  }
}

const detailToString = (d) => {
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d.msg || String(d);
};

export async function api(path, { method = "GET", body } = {}) {
  const headers = { "Content-Type": "application/json" };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API}/api${path}`, {
    method,
    headers,
    credentials: "include",
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (res.status === 204) return null;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, detailToString(data.detail));
  return data;
}

// ---- formatting (UK local time everywhere) ----
const UK = "Europe/London";
export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(Number(n || 0));
export const fmtDateTime = (iso) =>
  iso ? new Intl.DateTimeFormat("en-GB", { timeZone: UK, day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(iso)) : "";
export const fmtDate = (ymd) => {
  if (!ymd) return "";
  const [y, m, d] = ymd.split("-").map(Number);
  return new Intl.DateTimeFormat("en-GB", { timeZone: "UTC", weekday: "short", day: "numeric", month: "short", year: "numeric" }).format(new Date(Date.UTC(y, m - 1, d)));
};
export const fmtMonth = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Intl.DateTimeFormat("en-GB", { timeZone: "UTC", month: "short", year: "2-digit" }).format(new Date(Date.UTC(y, m - 1, 1)));
};
/** Today's date in the UK as YYYY-MM-DD. */
export const ukToday = () => {
  const p = new Intl.DateTimeFormat("en-GB", { timeZone: UK, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date());
  const g = (t) => p.find((x) => x.type === t).value;
  return `${g("year")}-${g("month")}-${g("day")}`;
};
export const telHref = (phone) => `tel:${String(phone || "").replace(/[^\d+]/g, "")}`;
export const waHref = (phone, text) => {
  let digits = String(phone || "").replace(/\D/g, "");
  if (digits.startsWith("0")) digits = `44${digits.slice(1)}`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
};

export const ENQUIRY_STATUS = {
  new: { label: "New", cls: "bg-brand text-white" },
  contacted: { label: "Contacted", cls: "bg-amber-100 text-amber-800" },
  quoted: { label: "Quoted", cls: "bg-violet-100 text-violet-800" },
  won: { label: "Won", cls: "bg-emerald-100 text-emerald-800" },
  lost: { label: "Lost", cls: "bg-slate-200 text-slate-700" },
};
export const JOB_STATUS = {
  won: { label: "Won", cls: "bg-emerald-100 text-emerald-800" },
  in_progress: { label: "In progress", cls: "bg-brand text-white" },
  completed: { label: "Completed", cls: "bg-navy text-white" },
  on_hold: { label: "On hold", cls: "bg-amber-100 text-amber-800" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-700" },
};
